import { entities } from "@oxygen/concepts";
import type { LucideIcon } from "lucide-react";
import { Bell, LayoutDashboard, Store } from "lucide-react";

export interface EntityConfig {
	icon: LucideIcon;
	color: string;
	label: string;
}

const fromShared = (id: keyof typeof entities): EntityConfig => {
	const e = entities[id];
	return { icon: e.icon, color: e.color, label: e.label.plural };
};

export const ENTITY_CONFIG: Record<string, EntityConfig> = {
	// Shared concepts (visual source of truth in @oxygen/concepts)
	dashboard: fromShared("dashboard"),
	payments: fromShared("payments"),
	orders: fromShared("orders"),
	payment_links: fromShared("payment_links"),
	finances: fromShared("finances"),
	customers: fromShared("customers"),
	developer: fromShared("developer"),
	support: fromShared("support"),

	// Dashboard-only
	manage_merchants: {
		icon: Store,
		color: "#8b5cf6",
		label: "Manage Merchants",
	},
	notifications: {
		icon: Bell,
		color: "#f97316",
		label: "Notifications",
	},
};

const DEFAULT_CONFIG: EntityConfig = {
	icon: LayoutDashboard,
	color: "#6b7280",
	label: "Unknown",
};

export const getEntityConfig = (entity: string): EntityConfig =>
	ENTITY_CONFIG[entity.toLowerCase()] || DEFAULT_CONFIG;
